import AllPalettes from './AllPalettes.component';

export default AllPalettes;
